import "./styles/App.css";
import React, { useState } from "react"; // <-- 1) Import useState!
import BondRegistrationContext from "./store/BondRegistrationContext";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import { useNavigate } from "react-router-dom";
import AllRoutes from "./routes/index";
import config from "./config";
import "bootstrap/dist/css/bootstrap.min.css";

const oktaAuth = new OktaAuth(config.oidc);

const App = () => {
  const navigate = useNavigate();
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };


  const [bondRegistrationContextData, setBondRegistrationContextData] = useState({});

  if (!oktaAuth) {
    return null;
  }

  return (
    <div className="App">
      <BondRegistrationContext.Provider value={{  bondRegistrationContextData, setBondRegistrationContextData }}>
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <AllRoutes />
        </Security>
      </BondRegistrationContext.Provider>
    </div>
  );
};

export default App;
